export const CHAT_WITH = "chat with";
export const SPLASH_TOP_BANNER =
  "https://lpcdn.exlyapp.com/creator-tool/assets/images/splash_top_banner.png";
export const DEFAULT_BG_COLOR = "#F3F4F6";
